module.exports = __webpack_public_path__ + "d3d424e9cf63915170df92a093d25ed0.svg";